<div class="row list-container mat-card" [hidden]="projectChartService.loading$ | async">
    <div class="col-12 mb-2">
        <h3>{{ 'projects.customer-entry' | translate }}</h3>
    </div>
    @if (countsByCustomerTypeEntry && !countsByCustomerDepartmentEntry) {
        <div class="col-12">
            <ceres-chart
                type="pie"
                (select)="onSelect($event)"
                [height]="view[1]"
                [colors]="colorScheme"
                [data]="countsByCustomerTypeEntry"
            ></ceres-chart>
        </div>
    }
    @if (countsByCustomerDepartmentEntry) {
        <div class="col-12">
            <button
                class="widget-button a-button a-button--pwo a-icon a-icon--arrow-left-small"
                type="button"
                (click)="resetSelection()"
            >
                BACK
            </button>
            <ceres-chart
                type="pie"
                [height]="view[1]"
                [colors]="colorScheme"
                [data]="countsByCustomerDepartmentEntry"
            ></ceres-chart>
        </div>
    }
</div>
@if (projectChartService.loading$ | async) {
    <ceres-loading></ceres-loading>
}
